export default [
    ".env",
    ".env.local",
    ".ui5deployrc",
    "mockserver.config.ts",
    "package.json",
    "README.md",
    "http/http-client.env.json",
    "http/http-client.private.env.json",
    "http/main-service.http",
    "src/app.config.ts",
    "src/index.html",
    "ui5/Component.ts",
    "ui5/flpSandbox.html",
    "ui5/manifest.json",
];
